import CustomInput from "@components/CustomInput/CustomInput";
import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const InvoiceDetails = ({
  numeroInvoice, // <-- ajoute cette prop
  isUpdate, // <-- ajoute cette prop pour savoir si on est en mode update
  setDateDeFacturation,
  dateDeFacturation,
  setDateEcheance,
  dateEcheance,
  isLoadingNextNumber,
  nextInvoiceData,
  handleAddExtraInput,
  extraInputs,
  handleExtraInputChange,
  dureeEcheance,
  setDureeEcheance,
  handleRemoveExtraInput,
  engagementId,
  setEngagementId,
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        backgroundColor: "#f8fbff",
        padding: "1.5rem",
        borderRadius: "16px",
      }}>
      <p className="detail-title">{t("invoice.details_title")}</p>

      <Stack className="invoice-create-dates" sx={{}}>
        <div className="invoice-dates">
          <div className="invoice-dates-part1">
            <CustomInput
              classname={"date-input"}
              label={t("invoice.invoice_date")}
              onChange={(e) => setDateDeFacturation(e.target.value)}
              value={dateDeFacturation}
              type={"date"}
            />
            <CustomInput
              classname={"date-input"}
              label={t("invoice.due_date_invoice")}
              onChange={(e) => setDateEcheance(e.target.value)}
              value={dateEcheance}
              type={"date"}
            />
          </div>
          <div>
            <CustomInput
              classname={"duration-input invoice-dates-part2"}
              label={t("invoice.due_duration")}
              type="number"
              min={1}
              value={dureeEcheance}
              onChange={(e) => setDureeEcheance(Number(e.target.value))}
            />
          </div>
        </div>

        <div className="">
          <CustomInput
            classname={"invoice-number"}
            label={t("invoice.invoice_number")}
            value={
              isUpdate
                ? numeroInvoice || ""
                : isLoadingNextNumber
                ? t("invoice.loading_companies")
                : nextInvoiceData?.data?.numeroInvoice || ""
            }
            type={"text"}
            isReadOnly={true}
            isDisabled={true}
          />
        </div>
      </Stack>
      <Stack
        className="invoice-columns"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
        }}>
        <div className="form-group">
          <div className="extra-input-div">
            <label>{t("invoice.custom_fields")}</label>

            {/* BOUTON AU DESSUS */}
            <button
              type="button"
              onClick={handleAddExtraInput}
              className="btn-add-line"
              style={{
                marginBottom: 12,
                backgroundColor: "#000000",
                color: " white",
              }}>
              {t("invoice.add_field") || "Ajouter un champ"}
            </button>
          </div>

          {/* CHAMPS DINAMIQUES EN DESSOUS */}
          {extraInputs.map((input, idx) => (
            <div
              key={idx}
              className="input-row"
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                marginBottom: 8,
                flexWrap: "wrap",
              }}>
              <input
                type="text"
                placeholder={t("invoice.label") || "Label"}
                value={input.label}
                className="table-input"
                onChange={(e) =>
                  handleExtraInputChange(idx, "label", e.target.value)
                }
                style={{ width: 150 }}
              />
              <input
                type="text"
                placeholder={t("invoice.value") || "Valeur"}
                value={input.value}
                className="table-input"
                onChange={(e) =>
                  handleExtraInputChange(idx, "value", e.target.value)
                }
                style={{ width: 200 }}
              />
              {extraInputs.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveExtraInput(idx)}
                  className="btn-add-line">
                  ×
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="form-group">
          <label>{t("invoice.engagement_id")}</label>
          <input
            type="text"
            value={engagementId}
            onChange={(e) => setEngagementId(e.target.value)}
            className="table-input"
            placeholder={t("invoice.engagement_id")}
          />
        </div>
      </Stack>
    </Stack>
  );
};

export default InvoiceDetails;
